import React, { useState } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { useDispatch } from 'react-redux'
import styles from './styles'
import { AssignmentTypes } from 'src/model/assignment'
import { Description } from './components'
import NamingModal from 'src/components/naming-modal'
const CreateCourse = props => {
  const { closeComponentBox, fromChat, sendMessage, classes } = props
  const collection = window.location.pathname.split('create-course/')[1] || ''
  const dispatch = useDispatch()
  const [showNamingModal, setShowNamingModal] = useState(false)

  return (
    <div className={classes.page}>
      <div className={classes.content}>
        <Description
          classes={classes}
          fromChat={fromChat}
          closeComponentBox={closeComponentBox}
          sendMessage={sendMessage}
        />
      </div>

      {showNamingModal && (
        <NamingModal
          classes={classes}
          dispatch={dispatch}
          id={collection}
          handleCloseModal={() => setShowNamingModal(false)}
          isModalOpen={showNamingModal}
          selectedAssignmentType={AssignmentTypes.ONETIME}
        />
      )}
    </div>
  )
}

export default withStyles(styles)(CreateCourse)
